export const lightTheme = {
  body: '#D7CAAA',
  text: '#363537',
  toggleBorder: '#fff',
  gradient: 'linear-gradient(#39598A, #79D7ED)',
  about: {
    backgroundColor: '#fff',
    h1Color: 'black',
    polaroidSpan: '#fff',
    cardBackground: '#fff',
    cardHeaderBackground: 'rgba(0,0,0,.03)',
    cardColor: 'black',
  },
  portfolio: {
    polaroidSpan: '#fff',
    cardBackground: '#fff',
    cardColor: 'black',
    dateBackground: '#696969',
    modalBackground: '#fff',
    modalCardColor: '#d7caaa',
  },
  experience: {
    iconBackground: '#AE944F',
    experienceChipColor: '#f9f5e9',
  },
};

export const darkTheme = {
  body: '#494949',
  text: '#FAFAFA',
  toggleBorder: '#6B8096',
  gradient: 'linear-gradient(#091236, #1E215D)',
  about: {
    backgroundColor: '#7f7f7f',
    h1Color: 'white',
    polaroidSpan: '#6d6d6d',
    cardBackground: '#6d6d6d',
    cardHeaderBackground: 'rgba(0,0,0,.03)',
    cardColor: 'white',
  },
  portfolio: {
    polaroidSpan: '#fff',
    cardBackground: '#363537',
    cardColor: 'black',
    dateBackground: '#918e97',
    modalBackground: '#5b5b5b',
    modalCardColor: '#8c8c8c',
  },
  experience: {
    iconBackground: '#919191',
    experienceChipColor: '#919191',
  },
};
